const triggerSigninUser = (country ,lang , sessionId ,externalRefId,customerRequestBody) => {
  
    const customerHeaders = {
        "Accept-Language": `${lang}-${country}`,
        "Content-Type": `application/json`,
        "x-wu-correlationId":  sessionId,
        "x-wu-externalRefId":  externalRefId,
        "WuCountryCode": country,
        "WuLanguageCode": lang,
        "x-wu-sessionId": sessionId,
        "accept": `application/json`,
        "x-wu-operationName": "signIn",
        "x-wu-global-mfa" :true,
        "isrrenabled":false,
        "isAutoEnabled":true,
        "canary":false,
        "SOURCE":"ExpPlatform",
        "CALLTRACE":"Web",
        "DEVICEDETAILS":"Browser",
        "DISPLAYSYSTEM":"Web",
        "platform":"nextgen",
        "x-wu-apiKey": 1978,
        "x-wu-accesscode":"RtYV3XDz9EA",
        "x-wu-session-version":2
      };

      const requestOptions = {
        method: "POST",
        body: JSON.stringify(customerRequestBody),
        headers: customerHeaders,
      };
    
     try {
      return fetchApiWu("/auth/v2/signIn", requestOptions, "signIn").then(
        (response) => {
          return response; 
        }
      );
     } catch (e) {
       console.log(e);
       return "error";
     }
    
    }

window.queryData.triggerSigninUser = triggerSigninUser;